export const HEADER_I18N_NS = 'bb-i18n';
